export const queryStatusColors = {
  UnderReview: "yellow",
  Resolved: "green",
};

export const queryStatusLabels = {
  UnderReview: "Under review",
  Resolved: "Resolved",
};

// A simple fixed set for now (not merchant-configurable like query reasons).
export const resolutionReasons = [
  "Invoice correct – payment due",
  "Credit note issued",
  "Invoice corrected / reissued",
  "Written off",
  "Duplicate query",
  "Other",
];

// Fallback labels only. The service's GET api/queries/reasons is the source of truth (T1.3);
// these are used until that fetch resolves.
export const queryReasonLabels = {
  ThisIsntMyInvoice: "This isn't my invoice",
  NeedCopyOfInvoice: "Need a copy of this invoice",
  NeedCopyOfInvoiceOrStatement: "Need a copy of an invoice or statement",
  PriceDoesntMatch: "Price doesn't match",
  OrderNotDelivered: "Order not delivered",
  MissingItemsShortDelivery: "Missing items / short delivery",
  ReturnNotCredited: "Return not credited",
  DamagedOnDelivery: "Damaged on delivery",
  WrongItemSupplied: "Wrong item supplied",
  BilledTwice: "Billed twice",
  PaymentAllocatedWrong: "Payment allocated wrong",
  CreditLimitQuery: "Credit limit query",
  SomethingElse: "Something else",
};

export const isTerminalQueryStatus = (status) => status === "Resolved";

const MS_PER_DAY = 24 * 60 * 60 * 1000;

const startOfDayMs = (date) => {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d.getTime();
};

// Whole calendar days between two instants, so the count ticks down by one each day
// regardless of the time of day the query was raised.
const wholeDaysBetween = (from, to) =>
  Math.round((startOfDayMs(to) - startOfDayMs(from)) / MS_PER_DAY);

export const queryAgeInDays = (createdAt) =>
  Math.max(0, wholeDaysBetween(createdAt, Date.now()));

// Whole calendar days until DueBy; negative when overdue.
export const queryDaysUntilDue = (dueBy) =>
  wholeDaysBetween(Date.now(), dueBy);

export const isQueryOverdue = (query) =>
  !isTerminalQueryStatus(query.status) && queryDaysUntilDue(query.dueBy) < 0;

export const queryModalTitle = (invoices) => {
  if (!invoices?.length) return "Query invoice";
  if (invoices.length === 1) return `Query ${invoices[0].transactionNumber}`;
  return `Query ${invoices.length} invoices`;
};
